<div *ngIf="soaker">

    <h2>{{soaker.name}}: {{soaker.numberOfDrinks}}</h2>

</div>
